import React  from 'react';
import { Box, Typography, Modal } from '@mui/material';
import ModalSymptomForm from './modalSymptomForm';


function SymptomModal(props){

  const style={
    position: 'absolute',
    top: '50%',
    left: {xs:"37%", sm:"30%"},
    transform: 'translate(-30%, -50%)',
    flex: {xs:"50%", sm:"90%"},
    display:"flex block",
    maxHeight:"90%",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    overflow:"scroll"
    };

const handleClose=()=>{props.setModalOpen(false)}

   const output=((props.symptomObject["symptomQuestionGroup"].length > 0) ? <ModalSymptomForm symptomObject={props.symptomObject} handleClose={handleClose}/> : <Typography variant='subtext3'> {"Sorry! Symptom form for this symptom not available."} </Typography>)

return(
<Modal
  open={props.modalOpen}
  onClose={handleClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
  <Box sx={style}>
    <Typography id="modal-modal-title" variant="h6" component="h2">
      {props.symptomObject["symptomText"]}
    </Typography>
    <Typography variant='subtext3'>Add any information you feel is relevant or important</Typography>
   <Box sx={{m:2}}>
    {output}
  </Box>
  </Box>
</Modal>)

}

export default SymptomModal